<template>
  <div class="container-fluid login-component">
    <div class="row imagem-logo">
      <div class="d-none d-md-block col-7 col-lg-8" />
      <div class="col-12 col-md-4">
        <div class="card-form">
          <div class="align-center">
            <form novalidate class="md-layout" @submit.prevent="validateUser">
              <md-card class="md-layout-item">
                <md-card-header>
                  <div class="md-title">Realizar Login</div>
                </md-card-header>

                <md-card-content>
                  <md-field :class="getValidationClass('email')">
                    <label for="email">Email</label>
                    <md-input
                      id="email"
                      v-model="form.email"
                      type="email"
                      name="email"
                      autocomplete="email"
                      :disabled="sending"
                    />
                    <span v-if="!$v.form.email.required" class="md-error"
                      >Email é obrigatório</span
                    >
                    <span v-else-if="!$v.form.email.email" class="md-error"
                      >Email inválido</span
                    >
                  </md-field>
                </md-card-content>

                <md-card-content>
                  <md-field :class="getValidationClass('password')">
                    <label for="password">Senha</label>
                    <md-input
                      id="password"
                      v-model="form.password"
                      type="password"
                      name="password"
                      autocomplete="password"
                      :disabled="sending"
                    />
                    <span v-if="!$v.form.password.required" class="md-error"
                      >Senha é obrigatório</span
                    >
                    <span v-if="!$v.form.password.minLength" class="md-error"
                      >Deve conter no mínimo 6 caracteres</span
                    >
                  </md-field>
                </md-card-content>

                <md-progress-bar v-if="sending" md-mode="indeterminate" />

                <md-card-actions>
                  <!--<md-button class="md-primary" :disabled="sending">
                                        Solicitar agendamento
                                    </md-button>-->
                  <md-button
                    type="submit"
                    class="md-primary"
                    :disabled="sending"
                  >
                    Entrar
                  </md-button>
                </md-card-actions>
              </md-card>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { email, minLength, required } from 'vuelidate/lib/validators'

import environment from '../../environment'
import http from '../../utils/http'

export default {
  name: 'Login',
  mixins: [validationMixin],
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      sending: false,
      environment,
    }
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    validateUser() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.login()
      }
    },
    async login() {
      this.sending = true

      // Instead of this timeout, here you can call your API

      let result
      try {
        result = await http.auth.login({
          ...this.form,
        })

        this.sending = false

        if (!result) {
          return
        }

        await this.$router.push({ name: 'Home' })
      } catch (e) {
        this.sending = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.login-component {
  height: 100%;

  & div {
    height: 100%;
  }
}

.align-center {
  padding-top: 20%;
}

.imagem-logo {
  background-image: url('../../assets/Flow - Marca App 02.png');
  background-repeat: repeat;
  background-size: contain;

  @media only screen and (max-width: 1200px) {
    background-size: cover;
  }

  @media only screen and (max-width: 768px) {
    background-position: bottom left;
    background-size: auto;
  }
}
</style>
